import ApeironComponent from '@/components/commons/apeiron-component.model';
import { ActividadRetribucion, MenuGenerico, PoblacionRetribucion } from '@/shared/model/ars/ars.model';
import CatalogosArs from '@/shared/model/ars/catalogos-ars.factory';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Component, Prop } from 'vue-property-decorator';
import { maxLength, minValue, required } from 'vuelidate/lib/validators';

const validations = function () {
  return {
    poblacionForm: {
      personasBeneficiadas: { required, minValue: minValue(0) },
      mujeresBeneficiadas: { required, minValue: minValue(0) },
      hombresBeneficiados: { required, minValue: minValue(0) },
      otrosBeneficiados: { required, minValue: minValue(0) },
      caracteristicasPoblacionBeneficiada: { required, maxLength: maxLength(500) },
    },
  };
};

@Component({
  validations,
})
export default class ActividadPoblacionArsComponent extends ApeironComponent {
  @Prop({ required: true })
  public readonly solucion!: Solucion;

  @Prop({ required: true })
  public readonly solicitud!: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  public poblacionForm: PoblacionRetribucion = new PoblacionRetribucion();

  public opcionesTipoPoblacionBeneficiada: Array<MenuGenerico> = [];

  public mounted(): void {
    this.opcionesTipoPoblacionBeneficiada =
      CatalogosArs.obtenerTiposPoblacion().map(tipo => new MenuGenerico(tipo.descripcion, tipo)) ?? [];
    this.get();
  }

  public get(): void {
    if (this.solicitud.poblacionRetribucion) {
      this.poblacionForm = PoblacionRetribucion.fromObject(this.solicitud.poblacionRetribucion);
    } else {
      this.poblacionForm = this.crearPoblacionFormVacio();
    }
  }

  private crearPoblacionFormVacio(): PoblacionRetribucion {
    return {
      personasBeneficiadas: 0,
      mujeresBeneficiadas: 0,
      hombresBeneficiados: 0,
      otrosBeneficiados: 0,
      caracteristicasPoblacionBeneficiada: '',
    };
  }

  public guardarPoblacion(): void {
    this.$emit('submit', { poblacionRetribucion: this.poblacionForm });
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }

  /**
   * Calcula el total de beneficiados sumando mujeres, hombres y otros.
   */
  get totalBeneficiados(): number {
    return (
      (this.poblacionForm.mujeresBeneficiadas ?? 0) +
      (this.poblacionForm.hombresBeneficiados ?? 0) +
      (this.poblacionForm.otrosBeneficiados ?? 0)
    );
  }

  get desactivarBoton(): boolean {
    return this.$v.$invalid;
  }
}
